import { useCallback, useState } from 'react';
import { CancelTokenSource } from 'axios';
import { api } from 'services/api';
import { OrderList } from '../types/orderList';
import { useErrorHandler } from 'providers/error-handler/error-handler';
import { BoardOrdersQueryParams } from '../BoardOrders';
import { useBoardOrderFormatter } from './useBoardOrderFormatter';

const queryParamsInitialValue: BoardOrdersQueryParams = {
  status: 'all',
  initial_date: new Date(),
  final_date: new Date(),
  page: 0,
  rows: 20,
};

export function useFetchBoardOrders() {
  const [queryParams, setQueryParams] = useState<BoardOrdersQueryParams>(queryParamsInitialValue);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<OrderList[]>([]);
  const [formatter] = useBoardOrderFormatter();
  const [total, setTotal] = useState(0);
  const { showErrorDialog } = useErrorHandler();

  const fetch = useCallback(
    (term: string, cancelToken?: CancelTokenSource) => {
      setLoading(true);

      api
        .get('orders', {
          params: { ...queryParams, term, type: 'board' },
          cancelToken: cancelToken?.token,
        })
        .then(response => {
          setOrders(formatter(response.data.data));
          setTotal(response.data.total);
        })
        .catch(error => {
          showErrorDialog({
            error,
            message: 'Não foi possível recuperar os pedidos',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [formatter, showErrorDialog, queryParams]
  );

  return {
    fetch,
    loading,
    total,
    queryParams,
    setQueryParams,
    orders,
    setOrders,
  };
}
